import React from "react";

import Editor from './EditorArticle'
import EditorWrapper from '../../EditorWrapper'

import Pol from "../../common/PhotoOnLeft";
import EmptyArticle from "../../common/EmptyArticle";

const APhotoOnLeft = props => {
  var article = EmptyArticle();
  const settings = props.settings;
  const imageUrl = (settings['background-image'] ? settings['background-image'] : '');

  article.title = settings.title_normal;
  article.picture.img = (!!imageUrl ? window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.') : '');
  article.url = settings.link;
  article.partner = settings.partner;
  article.label = settings.label;
  article.player = settings.player;
  article.stats = (settings.stats ? settings.stats : { shares: '0', comments: '0' });
  article.background = settings.background;
  // props.onRegisterBox(props.blockId, props.id, 'title_normal')

  article.hasMobilePcs = props.blockSettings.pcs_background_mobile;
  article.hasDesktopPcs = props.blockSettings.pcs_background_desktop;

  return (
    <div className={props.classes + ' pos-relative'} {...props.events}>
      <EditorWrapper {...props} editor={Editor} />
      <Pol article={article} size={props.size} media={settings.media} />
    </div>
  );
};

export default APhotoOnLeft;
